<template>
<div>
<div class="car">
 <div class="pricingCard">
    <section class="headings">
      <div class="titlePrice">
        <h4>Current plan</h4>
      </div>
    </section>
    <section class="heading">
      <div class="mar">
        <h6 class="titl">Beta Testing</h6>
        </div>
    </section>
    <section>
      <div class="price">
        <h4>Free</h4><br>
      </div>
    </section>
    <section class="abc">
      <div class="offeritems">
        <div  class="offerings">
          <div class="ticksymbol">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="25"
              height="25"
              fill="currentColor"
              class="bi bi-check"
              viewBox="0 0 16 16"
            >
              <path
                d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z"
              />
            </svg>

          </div>
          <div class="offer">
            <p>Experience the AI/ML driven pricing</p><hr>
          </div>
        </div>
         <section>
      <div class="offerite">
        <p>refresh rate : Manually triggered</p><hr>
        </div>
         <div class="offerite">
        <p>products     : Select a maximum of 10 products</p>
        </div>
    </section>
      </div>
     
    </section>
    
  </div>
  </div>
   <div class="disclaimer">
  <p>Disclaimer : We will need some historic data for the price optimisation module( Minimum of 6 months with few transactions every week for each products). If there is no data, this module wont give any results</p>
  </div>
  </div>
  <!-- <div class="pricing">
    <div class="pricingPageHeadings">
      <div class="pricingHeading">
        Choose Your Plan
      </div>
      <div class="subheading">
        We Create Maximum Value For You
      </div>
    </div>
    <div class="pricingCards">
      <div>
      <PricingCard
        title="LEVEL-1"
        :price="price.basic"
        offerings="Revenue upto $5000"      
        />
         <div style="margin-left:10rem;">
        <q-btn @click="loggin" color="primary" rounded>Get Started</q-btn>
      </div>
      </div>

      <div>
        
      <PricingCard 
      title="LEVEL-2" 
      :price="price.pro"
      offerings="Revenue $5000-$10000" 
      />
      <div style="margin-left:10rem;">
        <q-btn @click="loggin" color="primary" rounded>Get Started</q-btn>
      </div>
      </div>
      <div>
      <PricingCard
        title="LEVEL-3"
        :price="price.premium"
        offerings="Revenue $10000 and above"
      />
      <div style="margin-left:10rem;">
        <q-btn @click="loggin" color="primary" rounded>Get Started</q-btn>
      </div>
      </div>
    </div>
    <div class="wave">
      <img src="../assets/illustrations/Vector.svg" alt="img" />
    </div>
  </div>-->

</template>

<script>
import PricingCard from "../utilities/Components/Card/pricingCards";
export default {
  data() {
    return {
      price: {
        basic: 9.99,
        pro: 19.99,
        premium: 29.99,
      },
      // offers: {
      //   basic:,
      //   pro: "To make revenue upto",
      //   premium: "To make revenue upto",
      // },
    };
  },
  components: {
    PricingCard,
  },
  methods:{
    loggin(){
      this.$q.notify({
        message:"please login to continue",
        color:"red",
      });
      this.$router.push({
        name:"UnloggedHome",
      })
    }
  }
};
</script>

<style scoped>
@import "./style.css";
.heading{
 align-items:center;
 margin-left:4.5rem;
 margin-top:-6rem;
}
.offer{
  margin-bottom:0rem;
}
.offerite{
  margin-top:0rem;
  text-align:center;
}
.car{
  margin-left:35%;
  margin-top:5%;
}
.titl{
  margin-right:0px;
}
.disclaimer{
  text-align:center;
  margin:auto;
}

</style>